var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopNavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "balance",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.742,
    height: 14.742,
    viewBox: "0 0 14.742 14.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M128.774,452.3a1.3,1.3,0,0,0-1.3-1.3H122.3a1.3,1.3,0,0,0-1.3,1.3v.461h7.774Z",
    transform: "translate(-117.516 -438.014)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3013",
    "data-name": "Path 3013",
    d: "M13.878,3.484V2.62H8.587A1.294,1.294,0,0,0,7.8,1.836V0H6.939V1.836a1.294,1.294,0,0,0-.784.784H.864v.864h1.08L0,8.235a2.162,2.162,0,0,0,2.159,2.159h.864A2.162,2.162,0,0,0,5.183,8.235L3.23,3.484H6.155a1.294,1.294,0,0,0,.784.784v6.173a2.163,2.163,0,0,0-1.684,1.68H9.487A2.163,2.163,0,0,0,7.8,10.442V4.268a1.294,1.294,0,0,0,.784-.784H11.5L9.559,8.235a2.162,2.162,0,0,0,2.159,2.159h.864a2.162,2.162,0,0,0,2.159-2.159L12.79,3.484ZM4.1,7.8H1.08L2.591,4.175Zm9.559,0H10.639l1.512-3.628Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavIcon);
export default __webpack_public_path__ + "static/media/topNav-icon.613da355fb9fa06c2987416c79ab0e23.svg";
export { ForwardRef as ReactComponent };